import styled, { css } from 'styled-components'

export const Button = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    border-radius: 8px;
    font-family: Spartan, -apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.15;
    width: 100%;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s, opacity 0.2s;

    ${({ primary }) => primary ? css`
        color: #ffffff;
        background-color: #1299b8;
        border: 1px solid #1299b8;

        &:hover {
            background-color: #0f85a0;
            border-color: #0f85a0;
            text-decoration: none;
        }
    ` : css`
        color: #18182d;
        background-color: #f2f2f2;
        border: 1px solid #e0e0e0;
        box-shadow: rgba(0, 0, 0, 0.03) 0px 1px 2px 0px;

        &:hover {
            background-color: #e6e6e6;
            border-color: #d0d0d0;
            text-decoration: none;
        }
    `}

    &:focus {
        outline: none;
    }

    a {
        color: inherit;
        text-decoration: none;
    }
`
